module.exports = __webpack_public_path__ + "static/skyline-32b47c1c294ae04a097d8ac260dfda3d.svg";